import {FETCH_EMPLOYMENTS_REQUEST, FETCH_EMPLOYMENTS_SUCCES, FETCH_EMPLOYMENTS_ERROR} from '../constants/Employments'
import { jsonGet, errorHandler } from '../utils/Request';
import getFilterParameters from '../utils/getFilterParameters';

const loadEmployments = (filter) => (dispatch) => {
  const parameters = getFilterParameters(filter, 'employment');
  const apiUrl = `/personal/employment/list/${parameters ? parameters : '' }`;
  dispatch({
    type: FETCH_EMPLOYMENTS_REQUEST,
  });
  return jsonGet(apiUrl)
    .then(json => {
      dispatch({
        type: FETCH_EMPLOYMENTS_SUCCES,
        payload: json,
      });
    })
    .catch((e) => {
      dispatch({
        type: FETCH_EMPLOYMENTS_ERROR
      });
      errorHandler(e);
    });
};

export { loadEmployments };



// WEBPACK FOOTER //
// ./src/actions/EmploymentsActions.js